import VehicleEquipmentDetails from "./VehicleEquipmentDetails";

export default VehicleEquipmentDetails;
